export const faqs = [
  {
    q: '17爆料网的线索主要来自哪里？',
    a: '线索有三类来源：一是知情人士主动提供的内部消息，二是公开通告、路透画面与平台数据等可查证材料，三是读者通过投稿入口提交的第一手见闻。所有线索都会经过交叉比对后才进入整理流程，单一信源的内容会明确标注为“待核实”。',
  },
  {
    q: '怎样判断一条爆料是否可靠？',
    a: '我们通常看三点：是否有至少两个互相独立的信源指向同一结论；时间线是否自洽、能否被公开材料印证；关键细节是否具体到可验证。文章里会区分“已核实”“多方信源”“待回应”等状态，方便你自己判断。',
  },
  {
    q: '我发现线索，如何投稿给17爆料网？',
    a: '可以前往“我要爆料”页面提交。建议写清事件发生时间、地点、你所处的角色，以及能佐证的关键细节。如果是内部消息，请尽量说明信息的转述层级，帮助我们评估可信度。',
  },
  {
    q: '网站内容涉及隐私信息吗？',
    a: '不会。我们在整理时会对非公开发言人、普通当事人做匿名化处理，也不会公开任何私人联系方式、住址或身份证明类信息。与公共利益无关的私人细节不在我们的整理范围之内。',
  },
  {
    q: '内容多久更新一次？',
    a: '热点高峰期每天多次更新，普通时段保持每日整理。首页“最新爆料”按发布时间排序，独家追踪栏目则会在事件有实质进展时更新原有时间线，而不是重复发布。',
  },
  {
    q: '可以转载17爆料网的内容吗？',
    a: '欢迎注明出处的合理引用与转载，请保留标题、来源与原文链接，不要修改事件结论。商业用途或整站搬运请先通过邮箱与我们联系。',
  },
];